import React from 'react'
import './video.styles.scss'
import { useTranslation } from 'react-i18next'

const VideoContainer = () => {
    const {t} = useTranslation();

    return (
        <div className='video'>
            <label aria-label={t("home.possibility")}>{t("home.possibility")}</label>
            <iframe aria-label="Video di retapps per smartbip" title='Video RetAPPs' className='video-box' src='https://www.youtube.com/embed/8lrjAhDmMTk?si=UlPmJryCEn3ZXfgN' />
        </div>
    )
}

export default VideoContainer